import * as React from 'react';
import { usePreference } from 'ra-core';
import { useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { CustomFieldsSelector } from '@/components/global/fields/CustomFieldsSelector';

export const CustomDatagridEditor = () => {
    const [availableColumns] = usePreference('availableColumns', []);
    const [columns] = usePreference('columns', []);
    const [omit] = usePreference('omit', []);
    const translate = useTranslate();

    return (
        <Box>
            <Typography variant='h6' gutterBottom>
                {translate('common.configureColumns')}
            </Typography>
            <CustomFieldsSelector availableColumns={availableColumns} columns={columns} omit={omit} />
        </Box>
    );
};
